import React, { lazy } from "react";
import { useRoutes } from "react-router";
import Loadable from "../view/common/component/Loadable";
import EditProduct from "../view/seller/EditProduct";
import Privacy from "../view/common/component/Privacy";

const MainLayout = Loadable(lazy(() => import('../layout/MainLayout')));
const ProductDetails = Loadable(lazy(() => import('../view/common/ProductDetails')));
const Profile = Loadable(lazy(() => import('../view/common/Profile')));
const Messages = Loadable(lazy(() => import('../view/common/Messages')));
const AddProduct = Loadable(lazy(() => import('../view/seller/AddProduct')));
const PreviewProduct = Loadable(lazy(() => import('../view/seller/PreviewProduct')));
const ApprovalRequest = Loadable(lazy(() => import('../view/seller/ApprovalRequest')));
const Subscription = Loadable(lazy(() => import('../view/seller/Subscription')));
const SellerProductLists = Loadable(lazy(() => import('../view/seller/SellerProductLists')));
const MinimalLayout = Loadable(lazy(() => import('../layout/MinimalLayout')));
const Landing = Loadable(lazy(() => import('../view/common/Landing')));
const About = Loadable(lazy(() => import('../view/common/About')));

export default function SellerRoutes() {

  const list = {
    children: [
      { path: '/', element: <MinimalLayout> <Landing/> </MinimalLayout>},
      { path: '/about', element: <MinimalLayout> <About/> </MinimalLayout>},
      { path: '/product-details/:id', element: <MainLayout> <ProductDetails /> </MainLayout> },
      { path: '/profile', element: <MainLayout> <Profile /> </MainLayout> },
      { path: '/chat', element: <MainLayout> <Messages /> </MainLayout> },
      { path: '/subscription', element: <MainLayout> <Subscription /> </MainLayout> },
      { path: '/add-new-product', element: <MainLayout> <AddProduct /> </MainLayout> }, 
      { path: '/preview', element: <MainLayout> <PreviewProduct /> </MainLayout> },
      { path: '/approval-request', element: <MainLayout> <ApprovalRequest /> </MainLayout> },
      { path: '/products-list', element: <MainLayout> <SellerProductLists /> </MainLayout> },
      { path: '/edit-product/:id', element: <MainLayout> <EditProduct /> </MainLayout> },
      { path: '/privacy', element: <MinimalLayout> <Privacy/> </MinimalLayout>},
      { path: '*', element: <MinimalLayout> <Landing/> </MinimalLayout> }
    ],
  };

  return useRoutes([list]);
}
